import { render, staticRenderFns } from "./channel-user-edit.vue?vue&type=template&id=d9760b90&"
import script from "./channel-user-edit.vue?vue&type=script&lang=js&"
export * from "./channel-user-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports